import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { IRedux } from '../_store/types';
import { useSelector } from 'react-redux';
import oauthService from '../_service/oauth.service';
import { authActions } from '../_store/auth/auth.slice';
import { toaster } from '@/components/ui/toaster';
import { useSearchParams } from 'next/navigation';

export default function useGoogleAuth() {
  const dispatch = useDispatch();
  const searchParams = useSearchParams();
  const credential = searchParams.get('credential');
  const settings = useSelector((state: IRedux) => state.settings.data);

  useEffect(() => {
    const authorize = async () => {
      if (!credential) return;

      try {
        // Try to sign in first
        const signInResponse = await oauthService.signIn({
          token: credential,
          shipper_id: settings?.shipper_id,
        });
        dispatch(
          authActions.setUser(signInResponse?.data)
        );
        toaster.create({
          title: 'You have signed in successfully!',
          type: 'success',
        });
      } catch (error) {
        // If sign in fails, try to sign up
        try {
          const signUpResponse = await oauthService.signUp({
            token: credential,
            shipper_id: settings?.shipper_id,
          });
          dispatch(
            authActions.setUser(signUpResponse?.data)
          );
          toaster.create({
            title: 'You have signed up successfully!',
            type: 'success',
          });
        } catch (signUpError) {
          toaster.create({ title: 'something went wrong!' });
        }
      }
    };

    authorize();
  }, [credential, dispatch, settings?.shipper_id]);

  return;
}
